export default "__VITE_ASSET__BhV2KR70__"